import React, { useContext } from 'react';
import { BrowserRouter, HashRouter, Switch, Route, Redirect} from 'react-router-dom';
import { ThemeProvider, theme as builtinThemes } from '@social-solutions/component-library';
import theme from 'theme';
import IdentityProviders from 'components/IdentityProviders/IdentityProviders.renderer';
import AuthError from 'components/AuthError/AuthError';
import Logout from 'components/Logout/Logout';
import SiteListRenderer from 'components/SiteList/SiteList.renderer';
import { IntegrationContext } from 'helpers/integration/IntegrationContext';

const RouteList: React.FC = () => {
    const integration = useContext(IntegrationContext);
    return (
        <ThemeProvider theme={{ ...builtinThemes(), ...theme }}>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/public/logout" component={() => <Logout />} />
                    <Route exact path='/public/logout/:productType' component={() => <Logout />} />
                    <Route exact path='/public/auth-error' component={() => <AuthError />} />
                    <Route exact path='/public/auth-error/:productType' component={() => <AuthError />} />
                    <Route exact path='/auth/site-selection' component={() => <SiteListRenderer />}/>
                    <Route path='/'>
                        <HashRouter>
                            <Route path = '/' render={() => <Redirect to='/configurations'/>} />
                            <Route path='/configurations' component={() => <IdentityProviders integrationProps={integration} />} />
                        </HashRouter>
                    </Route>
                </Switch>
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default RouteList;
